var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogouth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20V4H12.02V5H5V19H12.02V20H4ZM17.3156 14.6844C17.0006 14.9994 16.462 14.7763 16.462 14.3309V12.5H18.079H9.192V11.5H18.079H16.462V9.66911C16.462 9.22365 17.0006 9.00057 17.3156 9.31555L20 12L17.3156 14.6844Z",
    fill: "#F5C538"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouth);
export default __webpack_public_path__ + "static/media/logouth.4854c0b9c1440e75eec27e1e25ca743b.svg";
export { ForwardRef as ReactComponent };